var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAllArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "21px",
    height: "14px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M20.282,6.311 L15.643,0.871 C15.256,0.457 14.644,0.418 14.236,0.733 C13.829,1.48 13.767,1.699 14.94,2.93 L17.397,5.967 L1.615,5.967 C1.65,5.967 0.626,6.400 0.626,6.923 C0.626,7.445 1.75,7.878 1.615,7.878 L17.397,7.878 L14.94,11.752 C13.767,12.146 13.839,12.777 14.236,13.112 C14.644,13.447 15.307,13.368 15.643,12.974 L20.282,7.533 C20.588,7.120 20.557,6.706 20.282,6.311 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllArrow);
export default __webpack_public_path__ + "static/media/view-all-arrow.e53125bc10396b75fdb45bd347a9aa9e.svg";
export { ForwardRef as ReactComponent };